
<div [ngClass]="[initialized ? 'shown' : 'hidden']" style="position:relative;" class="dash-card-back dash-big">
  <div *ngIf="!loaded" class="float-top-left-spinner">{{'Loading...'|locale}}</div>

  <select class="float-top-right search-select-single" [(ngModel)]="date_range" (change)="onRangeChanged()">
    <option *ngFor="let record of date_ranges" value={{record.key}}>{{record.name | locale}}</option>  
  </select>
  <div id="chart_maintenance_history" class="dash-chart"></div>
</div>